<template>
  <div class="profile-container">
    <!-- <el-header>
      <div class="header-content">
        <div class="left-section">
          <el-button 
            icon="el-icon-back" 
            @click="goBack" 
            class="back-button"
          >
            Back
          </el-button>
        </div>
        <div class="center-section">
          <h1>User Profile</h1>
        </div>
        <div class="left-section">
          
        </div>
      </div>
    </el-header> -->
    <el-main>
      <el-card class="profile-card">
        <div class="profile-header">
          <div class="profile-main-info" style="display: flex; flex-direction: row; align-items: flex-start; gap: 24px;">
            <div class="avatar-container">
              <el-avatar 
                :size="100" 
                :src="userProfile.user_avatar_address_small"
                class="avatar"
                :style="{
                  border: getBorderStyleByUserType(userProfile.user_type),
                  backgroundColor: userProfile.user_avatar_address_small && userProfile.user_avatar_address_small !== '' && userProfile.user_avatar_address_small !== 'undefined' ? 'white' : '#e0e0e0',
                  fontSize: '40px',
                  color: getBorderStyleByUserType(userProfile.user_type).split(' ')[2]
                }"
              >
                {{ userProfile.user_avatar_address_small && userProfile.user_avatar_address_small !== '' && userProfile.user_avatar_address_small !== 'undefined' ? '' : userProfile.user_nickName?.charAt(0) }}
              </el-avatar>
              <span 
                class="user-type-badge" 
                :class="`user-type-${(userProfile.user_type || 'individual').toLowerCase()}`"
                :style="{ 
                  color: getBorderStyleByUserType(userProfile.user_type).split(' ')[2],
                  backgroundColor: `${getBorderStyleByUserType(userProfile.user_type).split(' ')[2]}22`
                }"
              >
                {{ getUserTypeLabel(userProfile.user_type) }}
              </span>
            </div>
            <div class="profile-info">
              <h2>{{ userProfile.user_nickName }}{{ userProfile._id && (userProfile._id.$oid || userProfile._id.$id) && (userProfile._id.$oid || userProfile._id.$id) === $store.state.user_id ? ' (You)' : '' }}</h2>
              <p class="signature" v-if="userProfile.user_signature && userProfile.user_signature !== ''">{{ userProfile.user_signature }}</p>
              <p class="inline-stats">
                <span v-if="userProfile.knowit_count > 0">{{ userProfile.knowit_count }} posts</span>
                <span v-if="collections.length > 0">{{ collections.length }} courses</span>
              </p>

            </div>
          </div>

          <div class="action-buttons" v-if="userProfile._id && (userProfile._id.$oid || userProfile._id.$id) && (userProfile._id.$oid || userProfile._id.$id) !== $store.state.user_id">
              <el-button 
                type="primary" 
                @click="handleFollow"
                :loading="following"
              >
                {{ isFollowed ? 'Unfollow' : 'Follow' }}
              </el-button>
              <!-- <el-button
                type="success"
                @click="handleChat"
                icon="el-icon-chat-dot-round"
              >
                Chat
              </el-button>
              <el-button
                type="success"
                @click="handleExchange"
              >
                Exchange
              </el-button> -->
            </div>
          <div class="action-buttons" v-if="userProfile._id && (userProfile._id.$oid || userProfile._id.$id) && (userProfile._id.$oid || userProfile._id.$id) === $store.state.user_id">
            <el-button
              type="primary"
              @click="$router.push('/personal')"
            >
              Edit Profile
            </el-button>
          </div>
        </div>

        <div class="profile-intro" v-if="userProfile.user_intro && userProfile.user_intro !== ''">
          <p>{{ userProfile.user_intro }}</p>
        </div>

        <el-tabs v-model="activeTab" class="profile-tabs">
          <!-- <el-tab-pane label="Latest" name="latest">
            <div class="latest-section">
              <div class="latest-row" v-if="userKnowits.length > 0">
                <div class="latest-row-header">
                  <span>Latest Posts</span>
                  <router-link v-if="userKnowits.length > 5 && userProfile && userProfile._id && (userProfile._id.$oid || userProfile._id.$id)" :to="{ name: 'Profile', query: { id: (userProfile._id.$oid || userProfile._id.$id) }, hash: '#posts' }" class="more-link">More</router-link>
                </div>
                <div class="latest-list">
                  <Post
                    v-for="post in userKnowits.slice(0, 5)"
                    :key="(post._id.$oid || post._id.$id)"
                    :post="post"
                    @like="handleLike"
                    @comment="handleComment"
                  />
                  <div v-if="userKnowits.length === 0" class="empty-state">
                    <p>No recent posts</p>
                  </div>
                </div>
              </div>
              <div class="latest-row" v-if="collections.length > 0">
                <div class="latest-row-header">
                  <span>Latest Courses</span>

                </div>
                <div class="latest-list">
                  <CollectionSimpleCard
                    v-for="collection in collections.slice(0, 5)"
                    :key="(collection._id.$oid || collection._id.$id)"
                    :collection="collection"
                    @click="goToCollection((collection._id.$oid || collection._id.$id))"
                  />
                  <div v-if="collections.length === 0" class="empty-state">
                    <p>No recent courses</p>
                  </div>
                </div>
              </div>
              <div class="latest-row" v-if="bundles.length > 0">
                <div class="latest-row-header">
                  <span>Latest Bundles</span>

                </div>
                <div class="latest-list">
                  <BundleSimple
                    v-for="bundle in bundles.slice(0, 5)"
                    :key="(bundle._id.$oid || bundle._id.$id)"
                    :bundle="bundle"
                    @click.native="goToBundle((bundle._id.$oid || bundle._id.$id))"
                  />
                  <div v-if="bundles.length === 0" class="empty-state">
                    <p>No recent bundles</p>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane> -->
          <!-- <el-tab-pane label="Recent Posts" name="posts" v-if="userKnowits.length > 0">
            <div class="knowits-list">
              <Post
                v-for="post in userKnowits"
                :key="(post._id.$oid || post._id.$id)"
                :post="post"
                @like="handleLike"
                @comment="handleComment"
              />
              <div v-if="userKnowits.length === 0" class="empty-state">
                <p>No public posts yet</p>
              </div>
            </div>
          </el-tab-pane> -->

          <el-tab-pane label="Courses" name="collections">
            <div class="collections-list">
              <CollectionSimpleCard
                v-for="collection in collections"
                :key="(collection._id.$oid || collection._id.$id)"
                :collection="collection"
                @click="goToCollection((collection._id.$oid || collection._id.$id))"
              />
              <div v-if="collections.length === 0" class="empty-state">
                <p>No courses yet</p>
              </div>
            </div>
          </el-tab-pane>
          
          <el-tab-pane label="Bundles" name="bundles" v-if="bundles.length > 0">
            <div class="bundles-list">
              <BundleSimple
                v-for="bundle in bundles"
                :key="(bundle._id.$oid || bundle._id.$id)"
                :bundle="bundle"
                @click.native="goToBundle((bundle._id.$oid || bundle._id.$id))"
              />
              <div v-if="bundles.length === 0" class="empty-state">
                <p>No bundles yet</p>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="Pulses" name="pulses" v-if="userProfile.creator_functionality_level === 'Pro' || userProfile.creator_functionality_level === 'Premium'">
            <div class="pulses-list">
              <div
                v-for="pulse in userPulses"
                :key="(pulse._id.$oid || pulse._id.$id)"
                class="pulse-wrapper"
              >
                <div class="pulse-time-label">
                  {{ formatPulseTime(pulse.display_date || pulse.updated_at || pulse.created_at) }}
                </div>
                <div class="pulse-item">
                  <div class="pulse-content" v-html="renderPulseContent(pulse.content)"></div>
                </div>
              </div>
              <div v-if="userPulses.length === 0" class="empty-state">
                <p>No pulses yet</p>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="Subscription Programs" name="subscriptions" v-if="subscriptionPrograms.length > 0">
            <div class="subscription-grid">
              <SubscriptionProgram
                v-for="program in subscriptionPrograms"
                :key="program._id?.$oid || program._id?.$id"
                :program="program"
                @subscribe="handleSubscribe(program)"
              />
              <div v-if="subscriptionPrograms.length === 0" class="empty-state">
                <p>No subscription programs available</p>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="My Following" name="following" v-if="userProfile._id && (userProfile._id.$oid || userProfile._id.$id) && (userProfile._id.$oid || userProfile._id.$id) === $store.state.user_id">
            <div class="following-list">
              <div v-if="followingLoading" class="loading-state">
                <i class="el-icon-loading"></i> Loading...
              </div>
              <div v-else-if="followingUsers.length > 0" class="users-grid">
                <div 
                  v-for="user in followingUsers" 
                  :key="(user._id.$oid || user._id.$id)"
                  class="user-card-wrapper"
                  @click="goToProfile((user._id.$oid || user._id.$id))"
                >
                  <div class="user-card-content">
                    <el-avatar 
                      :size="60" 
                      :src="user.user_avatar_address_small"
                      class="user-avatar"
                      :style="{
                        border: getBorderStyleByUserType(user.user_type),
                        backgroundColor: user.user_avatar_address_small && user.user_avatar_address_small !== '' && user.user_avatar_address_small !== 'undefined' ? 'white' : '#e0e0e0',
                        fontSize: '24px',
                        color: getBorderStyleByUserType(user.user_type).split(' ')[2]
                      }"
                    >
                      {{ user.user_avatar_address_small && user.user_avatar_address_small !== '' && user.user_avatar_address_small !== 'undefined' ? '' : user.user_nickName?.charAt(0) }}
                    </el-avatar>
                    <div class="user-info">
                      <h4>{{ user.user_nickName }}</h4>
                      <p class="user-signature">{{ user.user_signature || 'No signature' }}</p>
                      <p class="user-stats">
                        <span v-if="user.knowit_count">{{ user.knowit_count }} posts</span>
                        <span v-if="user.follower_count">{{ user.follower_count }} followers</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="empty-state">
                <p>You are not following anyone yet</p>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-main>
  </div>
</template>

<script>
import Post from '@/components/Post.vue'
import CollectionSimpleCard from '@/components/CollectionSimpleCard.vue'
import BundleSimple from '@/components/BundleSimple.vue'
import SubscriptionProgram from '@/components/SubscriptionProgram.vue'
import { postRequest } from '@/apis/front'

export default {
  name: 'Profile',
  components: {
    Post,
    CollectionSimpleCard,
    BundleSimple,
    SubscriptionProgram
  },
  data() {
    return {
      activeTab: 'collections',
      userProfile: {
        _id: { $id: '' },
        user_id: '',
        user_nickName: '',
        user_signature: '',
        user_intro: '',
        user_PMF: '',
        user_avatar_address_small: '',
        user_type: 'individual',
        knowit_count: 0,
        follower_count: 0,
        following_count: 0
      },
      userKnowits: [],
      isFollowed: false,
      following: false,
      collections: [],
      bundles: [],
      userPulses: [],
      subscriptionPrograms: [],
      subscriptionLoading: false,
      followingUsers: [],
      followingLoading: false
    }
  },
  created() {
    this.loadProfileData()
  },
  watch: {
    '$route.query.id': {
      handler(newId, oldId) {
        if (newId && newId !== oldId) {
          this.loadProfileData()
        }
      }
    }
  },
  methods: {
    async loadProfileData() {
      const userId = this.$route.query.id
      if (!userId) {
        this.$message.error('No user ID provided')
        return
      }

      // Reset data
      this.userProfile = {
        _id: { $id: '' },
        user_id: '',
        user_nickName: '',
        user_signature: '',
        user_intro: '',
        user_PMF: '',
        user_avatar_address_small: '',
        user_type: 'individual',
        knowit_count: 0,
        follower_count: 0,
        following_count: 0
      }
      this.userKnowits = []
      this.collections = []
      this.bundles = []
      this.userPulses = []
      this.subscriptionPrograms = []
      this.followingUsers = []
      this.isFollowed = false

      // Fetch all data
      await this.fetchUserProfile()
      this.fetchUserKnowits()
      this.checkFollowStatus()
      this.fetchUserCollections()
      this.fetchUserBundles()
      this.fetchUserPulses()
      this.fetchUserSubscriptionPrograms()

      // Fetch following list if it's the user's own profile
      if (userId === this.$store.state.user_id) {
        this.fetchFollowingUsers()
      }
    },
    getUserTypeLabel(userType) {
      const type = userType || 'individual';
      switch(type.toLowerCase()) {
        case 'individual':
          return 'Individual';
        case 'institution':
          return 'Institution';
        case 'agent':
          return 'AI Agent';
        default:
          return 'Individual';
      }
    },
    async fetchUserProfile() {
      try {
        const userId = this.$route.query.id
        if (!userId) {
          this.$message.error('No user ID provided')
          return
        }

        const response = await postRequest('getUserProfile', {
          user_id: userId
        })
        
        if (response.data.code === 0 && response.data.data) {
          // Merge the fetched data with default structure to ensure all fields exist
          this.userProfile = {
            ...this.userProfile,
            ...response.data.data,
            // Ensure _id structure exists
            _id: response.data.data._id || { $id: response.data.data.user_id || userId },
            // Ensure user_type has a default
            user_type: response.data.data.user_type || 'individual'
          }
        } else {
          this.$message.error(response.data.msg || 'Failed to load user profile')
        }
      } catch (error) {
        console.error('Error fetching user profile:', error)
        this.$message.error('Failed to load user profile')
      }
    },
    async fetchUserKnowits() {
      try {
        const userId = this.$route.query.id
        if (!userId) return

        const response = await postRequest('getUserPublicPosts', {
          user_id: userId,
          viewer_id: this.$store.state.user_id
        })
        
        if (response.data.code === 0) {
          this.userKnowits = response.data.data || []
        }
      } catch (error) {
        console.error('Error fetching user posts:', error)
        this.$message.error('Failed to load user posts')
      }
    },
    async checkFollowStatus() {
      try {
        const response = await postRequest('checkFollowStatus', {
          follower_id: this.$store.state.user_id,
          following_id: this.$route.query.id
        })
        
        if (response.data.code === 0) {
          this.isFollowed = response.data.data.is_following
        }
      } catch (error) {
        console.error('Error checking follow status:', error)
      }
    },
    async handleFollow() {
      this.following = true
      try {
        const response = await postRequest(this.isFollowed ? 'unfollowUser' : 'followUser', {
          follower_id: this.$store.state.user_id,
          following_id: this.$route.query.id
        })
        
        if (response.data.code === 0) {
          this.isFollowed = !this.isFollowed
          this.$message.success(this.isFollowed ? 'Followed successfully' : 'Unfollowed successfully')
          await this.fetchUserProfile() // Refresh counts
        } else {
          throw new Error(response.data.msg)
        }
      } catch (error) {
        this.$message.error(error.message || 'Operation failed')
      } finally {
        this.following = false
      }
    },
    handleExchange() {
      this.$router.push({
        path: '/exchange',
        query: { user_id: this.$route.query.id }
      })
    },
    handleLike(postId) {
      // Implement like functionality
    },
    handleComment(postId) {
      // Implement comment functionality
    },
    goBack() {
      this.$router.go(-1)
    },
    async fetchUserCollections() {
      try {
        const response = await postRequest('getUserPublicPostCollectionList', {
          user_id: this.$route.query.id
        })
        
        if (response.data.code === 0) {
          this.collections = response.data.data
        }
      } catch (error) {
        this.$message.error('Failed to load courses')
      }
    },
    goToCollection(collectionId) {
      console.log(collectionId)
      this.$store.dispatch('setTempCollectionId', collectionId)
      this.$router.push({ path: '/deck', query: { id: collectionId } })
    },
    async fetchUserBundles() {
      try {
        const response = await postRequest('getUserCollectionBundles', {
          user_id: this.$route.query.id
        })
        
        if (response.data.code === 0) {
          this.bundles = response.data.data
        }
      } catch (error) {
        this.$message.error('Failed to load bundles')
      }
    },
    goToBundle(bundleId) {
      console.log(bundleId)
      this.$store.dispatch('setTempBundleId', bundleId)
      this.$router.push('/bundle')
    },
    async fetchUserPulses() {
      try {
        const userId = this.$route.query.id
        if (!userId) return

        const response = await postRequest('getUserPulses', {
          user_id: userId
        })

        if (response.data.code === 0) {
          this.userPulses = response.data.data || []
        }
      } catch (error) {
        console.error('Error fetching user pulses:', error)
        this.$message.error('Failed to load user pulses')
      }
    },
    formatPulseTime(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp * 1000)
      const now = new Date()
      const diff = now - date

      // Less than 1 minute
      if (diff < 60000) {
        return 'Just now'
      }
      // Less than 1 hour
      if (diff < 3600000) {
        const minutes = Math.floor(diff / 60000)
        return `${minutes} minute${minutes > 1 ? 's' : ''} ago`
      }
      // Less than 1 day
      if (diff < 86400000) {
        const hours = Math.floor(diff / 3600000)
        return `${hours} hour${hours > 1 ? 's' : ''} ago`
      }
      // Less than 7 days
      if (diff < 604800000) {
        const days = Math.floor(diff / 86400000)
        return `${days} day${days > 1 ? 's' : ''} ago`
      }
      // More than 7 days
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
    },
    renderPulseContent(content) {
      if (!content) return ''

      // Check if content is HTML
      if (content.includes('<') && content.includes('>')) {
        return content
      }

      // Simple markdown rendering
      let html = content

      // Headers
      html = html.replace(/^### (.*$)/gim, '<h3>$1</h3>')
      html = html.replace(/^## (.*$)/gim, '<h2>$1</h2>')
      html = html.replace(/^# (.*$)/gim, '<h1>$1</h1>')

      // Bold
      html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')

      // Italic
      html = html.replace(/\*(.*?)\*/g, '<em>$1</em>')

      // Links
      html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank">$1</a>')

      // Line breaks
      html = html.replace(/\n/g, '<br>')

      return html
    },
    async fetchUserSubscriptionPrograms() {
      this.subscriptionLoading = true
      try {
        const response = await postRequest('getUserOpenSubscriptionPrograms', {
          user_id: this.$route.query.id
        })
        
        if (response.data.code === 0) {
          this.subscriptionPrograms = response.data.data
        } else {
          this.$message.error(response.data.msg || 'Failed to fetch subscription programs')
        }
      } catch (error) {
        console.error('Error fetching subscription programs:', error)
        this.$message.error('Failed to fetch subscription programs')
      } finally {
        this.subscriptionLoading = false
      }
    },
    handleSubscribe(program) {
      this.$router.push({
        path: '/subscription-order',
        query: { id: (program._id.$oid || program._id.$id) }
      })
    },
    getBorderStyleByUserType(userType) {
      // Default to Individual if not set
      const type = userType || 'individual';
      
      switch(type) {
        case 'individual':
          return '2px solid #1890ff'; // Theme blue border
        case 'institution':
          return '2px solid #67C23A'; // Green border for institutions
        case 'agent':
          return '2px solid #E6A23C'; // Orange border for agents
        default:
          return '1px solid #e0e0e0'; // Default gray border
      }
    },
    async fetchFollowingUsers() {
      this.followingLoading = true
      try {
        const response = await postRequest('getMyFollowedUsers', {
          user_id: this.$route.query.id
        })
        
        if (response.data.code === 0) {
          this.followingUsers = response.data.data
        } else {
          this.$message.error(response.data.msg || 'Failed to fetch following list')
        }
      } catch (error) {
        console.error('Error fetching following users:', error)
        this.$message.error('Failed to fetch following list')
      } finally {
        this.followingLoading = false
      }
    },
    goToProfile(userId) {
      this.$router.push({
        path: '/profile',
        query: { id: userId }
      })
    }
  }
}
</script>


<style scoped>
.avatar-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.avatar-container .user-type-badge {
  margin-top: -4px;
}
.profile-container {
  width: 100%;
}

.header-content {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  width: 100%;
}

.left-section {
  justify-self: start;
}

.center-section {
  justify-self: center;
}

h1 {
  margin: 0;
}

.el-header {
  background-color: #409EFF;
  color: white;
  text-align: center;
  padding: 20px 0;
  display: flex;
  align-items: center;
}

.profile-card {
  width: 90%;
  margin: 20px auto;
  padding: 30px;
}

.profile-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 30px;
}

.latest-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 12px;
  margin-bottom: 8px;
  padding: 0;
  background: #fff;
  border-radius: 4px;
  min-height: 60px;
}

.latest-row {
  margin-bottom: 32px;
}
.latest-row:last-child {
  margin-bottom: 0;
}

.latest-row-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 20px;
  
  color: #222;
  background: #f5f7fa;
  border-radius: 4px;
  padding: 10px 12px;
  margin-bottom: 18px;
  border-bottom: 2px solid #e4e7ed;
  letter-spacing: 0.5px;
}

.latest-list .more-link {
  flex: 1;
  text-align: right;
  font-size: 14px;
  color: #409eff;
  margin-top: 10px;
}



.signature {
  color: #606266;
  margin: 0;
}

.profile-intro {
  margin: 30px 0;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
}

.profile-intro h3 {
  margin: 0 0 10px 0;
  color: #303133;
}

.user-knowits {
  margin-top: 30px;
}

.user-knowits h3 {
  margin-bottom: 20px;
}

.knowits-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  width: 100%;
}

/* Add these styles to make the grid responsive and look good */
@media (max-width: 768px) {
  .knowits-list {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
}

@media (min-width: 1440px) {
  .knowits-list {
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  }
}

/* Ensure the grid items have consistent height */
.knowits-list > * {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Add this if you need to ensure the cards have a minimum height */
.knowits-list .el-card {
  height: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
}

/* Make sure the card body takes up all available space */
.knowits-list .el-card .el-card__body {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.empty-state {
  text-align: center;
  padding: 40px;
  color: #909399;
  background: #f8f9fa;
  border-radius: 8px;
}

.back-button {
  color: white;
  border: 1px solid white;
  background: transparent;
  margin-left: 20px;
}

.back-button:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border-color: white;
}

.action-buttons {
  display: flex;
  gap: 10px;
}

.user-collections {
  margin-top: 30px;
}

.collections-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 20px;
  
  width: calc(100% - 20px);
}

.profile-tabs {
  margin-top: 20px;
}

.el-tabs__content {
  padding: 20px 0;
}

.inline-stats {
  margin: 5px 0 0 0;
  color: #606266;
  font-size: 14px;
}

.inline-stats span {
  margin-right: 15px;
}

.bundles-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 20px;
  width: calc(100% - 20px);
}

.pulses-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
}

.pulse-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pulse-time-label {
  font-size: 13px;
  color: #606266;
  font-weight: 500;
  padding-left: 4px;
  margin-bottom: 4px;
}

.pulse-item {
  padding: 16px;
  background: #f5f7fa;
  border-radius: 8px;
  border-left: 3px solid #409EFF;
  transition: all 0.3s;
}

.pulse-item:hover {
  background: #e8f4ff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.pulse-content {
  font-size: 14px;
  color: #303133;
  line-height: 1.6;
  word-wrap: break-word;
}

.pulse-content h1,
.pulse-content h2,
.pulse-content h3 {
  margin: 4px 0 2px 0;
  font-weight: 600;
  color: #303133;
}

.pulse-content h1 {
  font-size: 16px;
}

.pulse-content h2 {
  font-size: 15px;
}

.pulse-content h3 {
  font-size: 14px;
}

.pulse-content p {
  margin: 4px 0;
}

.pulse-content strong {
  font-weight: 600;
  color: #303133;
}

.pulse-content em {
  font-style: italic;
}

.pulse-content a {
  color: #409EFF;
  text-decoration: none;
}

.pulse-content a:hover {
  text-decoration: underline;
}

/* User type indicator styles */
.user-type-badge {
  display: inline-block;
  padding: 2px 8px;
  margin-left: 8px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
}

.subscription-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  padding: 20px;
  width: 100%;
}

@media (max-width: 768px) {
  .subscription-grid {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
}

@media (min-width: 1440px) {
  .subscription-grid {
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  }
}

.following-list {
  width: 100%;
  min-height: 200px;
}

.loading-state {
  text-align: center;
  padding: 40px;
  color: #909399;
  font-size: 16px;
}

.users-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  padding: 10px;
}

.user-card-wrapper {
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.user-card-wrapper:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
  border-color: #409eff;
}

.user-card-content {
  display: flex;
  align-items: center;
  gap: 15px;
}

.user-avatar {
  flex-shrink: 0;
}

.user-info {
  flex: 1;
  min-width: 0;
}

.user-info h4 {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-signature {
  margin: 0 0 8px 0;
  font-size: 14px;
  color: #606266;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.4;
}

.user-stats {
  margin: 0;
  font-size: 13px;
  color: #909399;
}

.user-stats span {
  margin-right: 12px;
}

@media (max-width: 768px) {
  .users-grid {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  }
}

</style>
